import React, { useEffect } from "react";
import heroImg from "../assets/Contact us.png";

export default function ContactUs() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("active");
        });
      },
      { threshold: 0.15 }
    );
    elements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <>
      <style>{`
        /* HERO SECTION */
        .contact-hero {
          position: relative;
          width: 100%;
          height: 50vh;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .contact-hero img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(100%);
        }
        .contact-hero-title {
          position: absolute;
          color: white;
          font-size: 42px;
          font-weight: 500;
          letter-spacing: 1px;
          text-align: center;
        }

        /* CONTACT WRAPPER */
        .contact-wrapper {
          width: 80%;
          margin: 80px auto;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 50px;
          flex-wrap: wrap;
        }

        /* CONTACT INFO */
        .contact-info {
          flex: 1;
          background: #f7f9ff;
          padding: 40px;
          border-radius: 12px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.05);
        }
        .contact-info h2 {
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .contact-info p {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 12px;
        }

        /* CONTACT FORM */
        .contact-form {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 15px;
          background: #ffffff;
          padding: 40px;
          border-radius: 12px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.05);
        }
        .contact-form input,
        .contact-form textarea {
          width: 100%;
          padding: 14px 18px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 16px;
          transition: all 0.3s ease;
        }
        .contact-form input:focus,
        .contact-form textarea:focus {
          outline: none;
          border-color: #6f8cff;
          box-shadow: 0 0 5px rgba(111,140,255,0.3);
        }
        .contact-form textarea { height: 150px; resize: none; }

        .contact-form button {
          padding: 14px 25px;
          background: #6f8cff;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          align-self: flex-start;
          transition: all 0.3s ease;
        }
        .contact-form button:hover {
          background: #5a70e0;
        }

        /* MAP */
        .map-container {
          width: 80%;
          margin: 60px auto 100px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(0,0,0,0.05);
        }
        .map-container iframe { width: 100%; height: 400px; border: 0; }

        /* SCROLL ANIMATION */
        .reveal {
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.9s ease;
        }
        .reveal.active {
          opacity: 1;
          transform: translateY(0);
        }

        /* RESPONSIVE LAYOUT */

/* Large screens (1200px – 1024px) */
@media(max-width: 1200px) {
  .contact-wrapper {
    width: 90%;
    gap: 40px;
  }
}

/* Medium screens / Tablets (1024px – 768px) */
@media(max-width: 1024px) {
  .contact-wrapper {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .contact-info, .contact-form {
    width: 100%;
    max-width: 600px;
  }
}

/* Small screens / Mobile (768px – 480px) */
@media(max-width: 768px) {
  .contact-hero-title {
    font-size: 32px;
    padding: 0 20px;
  }

  .contact-wrapper {
    margin: 60px auto;
    gap: 30px;
  }

  .contact-info, .contact-form {
    padding: 30px 20px;
  }

  .contact-form button {
    width: 100%;
  }
}

/* Extra small screens / Small Mobile (480px and below) */
@media(max-width: 480px) {
  .contact-hero-title {
    font-size: 26px;
  }

  .contact-wrapper {
    width: 95%;
    margin: 50px auto;
  }

  .contact-info h2, .contact-form input, .contact-form textarea {
    font-size: 14px;
  }

  .contact-form button {
    font-size: 16px;
    padding: 12px;
  }
}
  @media (max-width: 768px) {
  .contact-hero {
    height: auto;
  }

  .contact-hero img {
    height: auto;
    object-fit: contain;
  }
}


      `}</style>

      {/* HERO */}
      <div className="contact-hero reveal">
        <img src={heroImg} alt="Contact Hero" />
        
      </div>

      {/* CONTACT SECTION */}
      <div className="contact-wrapper reveal">
        <div className="contact-info">
          <h2>Contact Information</h2>
          <p>📍 Gate No. 4, Metro station, Block K, Hauz Khas Enclave, Hauz Khas, New Delhi, Delhi - 110016</p>
          <p>📞 (+91) 93151 25347</p>
          <p>✉️ info@rapidwash.co.in</p>
          <p>We are available 24/7. Send us a message and our team will respond promptly to your query.</p>
        </div>

        <form className="contact-form reveal">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <input type="text" placeholder="Subject" />
          <textarea placeholder="Your Message" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>

      {/* MAP */}
     <div className="map-container reveal">
  <iframe
    title="Delhi Map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.752096670501!2d77.1976995753323!3d28.54717017571141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce34ce1d564d7%3A0x8f24bfae621501cc!2sRAPID%20WASH%20DRYCLEANERS!5e0!3m2!1sen!2sin!4v1767073957180!5m2!1sen!2sin"
    width="100%"
    height="450"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>

    </>
  );
}
